export default {
  image: 'A4_8.png',
  pdf: '220922_WA-MIWO_008_A4_8_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-MIWO-008',
    technicalValues: {
      soundReductionIndex: {
        output: '50,5',
        value: 50.5
      },
      heatTransferCoefficient: {
        output: '0,14',
        value: 0.14
      },
      fireBehavior: {
        output: 'nichtbrennbar (A2-s1, d0)',
        value: 'A1A2'
      },
      fireResistanceOuter: {
        output: 'F 90-B',
        value: 'F-90-B'
      },
      fireResistanceInner: {
        output: 'F 60-B',
        value: 'F-60-B'
      }
    },
    name: 'Wandaufbau mit Mineralwolle l Aufbau 8',
    construction: {
      composition: [
        {
          output: 'mineralischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'min-1'
        },
        {
          output: '100 mm Sto-Speedlamelle Typ ll',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'msp-100'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '60/180',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-180'
        },
        {
          output: '180 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-180'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'if-12'
        },
        {
          output: '12,5 mm Gipskartonplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'in-12'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '326,5',
        value: 326
      }
    }
  }
}
